import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Resource } from '@df/catalog/resource';
import { Route } from '@df/catalog/route/route';
import { EdependencyLevel } from '../model';
import { RouteResolver } from './route.resolver';

declare module '@df/catalog/resource' {
    interface IResources {
        route: Resource<Route, string>;
    }
}

@Injectable({
    providedIn: 'root'
})
export class RouteResource extends Resource<Route, string> {
    static override instance = Route;

    readonly invalidatesUniversal = false;
    readonly invalidatesPrerender = false;
    private routeResolver = inject(RouteResolver);
    private location = inject(Location);

    appInitialize() {
        // delay for class to be generated
        setTimeout(() => {
            // load route immediately without witing
            const path = this.location.path();
            if (!path.match(/^\/(checkout|basket|account|login|search)(($)|(\/.*)$)/)) {
                this.getCreate(this.routeResolver.cleanUrl(path)).load(1, { dependencyLevel: EdependencyLevel.details });
            }
        });
    }
}
